import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import KidsLandingData from './height-predictor-landing-form/KidsLandingData';
import { postDataFetcher } from '../../dataFetcher';
import CONFIG_OBJECT from '../../config/config';
import './baby_height_predictor.css';
import Results from './height-predictor-result/Results';
import HP_Constants from './height-predictor-constants/HP_Constants';
import { isMobile } from 'react-device-detect';
import configData from '../../temp/config';
import App_Constants from '../../app-constants/App_Constants';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

// Default Data to be used for Height-Predictor
let heightData = {
    genderType: '',
    motherHeight: 0,
    fatherHeight: 0,
    hiddenField: '',
    isToggled: false
}

const HeightPredictorCalculation = (props) => {
    // Setting component State here
    const [showForm, setShowForm] = useState(true);
    const [disableBtn, setDisableBtn] = useState(false);
    const [showDesc, setShowDesc] = useState(isMobile ? false : true);
    const [componentData, setComponentData] = useState({})
    const [heightPredictorData, setHeightPredictorData] = useState({
        showResult: false,
        apiData: {}
    });
    const [showEditForm, setShowEditForm] = useState(false);
    const [unit, setUnit] = useState('')

    //heightPredictorData.showResult = false

    // Using React Hook for setting the component Lay-out service response and caching it
    useEffect(() => {
        //fetching data from default layout-service called by jss app itself
        let componentData = props.fields
        setComponentData(componentData);
    }, [])

    // This function will be used for calculating the height of the Baby based on the params
    const calculateHeight = () => {
        // document.getElementsByName('mother')[0].blur();
        // document.getElementsByName('father')[0].blur();
        if (!document.getElementById("calculate-button-id").disabled) {
            // Here cheking the gender type and setting GUID as per gender
            let genderType = heightData.genderType === HP_Constants.BOY_LABEL ? componentData.genders[0].id : componentData.genders[1].id
            // Creating data to be sent in REST-Api
            let data = {
                height: heightData.motherHeight,
                partnerheight: heightData.fatherHeight,
                gender: `{${genderType}}`,
            };
            if (sessionStorage.getItem('unit') !== 'cm') {
                var motherHeight = heightData.motherHeight.toString().split("'")
                let m_feet = motherHeight[0]//Math.floor(heightData.motherHeight / 12);
                let m_inch = motherHeight.length == 2 ? (motherHeight[1] === "" ? 0 : motherHeight[1]) : 0;

                var fatherHeight = heightData.fatherHeight.toString().split("'")
                let f_feet = fatherHeight[0];
                let f_inch = fatherHeight.length == 2 ? (fatherHeight[1] === "" ? 0 : fatherHeight[1]) : 0;
                data.height = m_feet;
                data.heightInch = m_inch;

                data.partnerheight = f_feet
                data.partnerHeightInch = f_inch
            }
            //heightInch, partnerHeightInch
            if (isMobile) {
                setShowDesc(false)
                setShowForm(false)
                setShowEditForm(true)
            }
            setHeightPredictorData({
                showResult: false,
            })
            // Calling REST API Url
            postDataFetcher(`${CONFIG_OBJECT.HP_REST_URL}${App_Constants.SC_API_KEY}`, data)
                .then(res => {
                    console.log(res)
                    setHeightPredictorData({
                        showResult: true,
                        apiData: res.data.Data
                    })
                });
            document.getElementById("calculate-button-id").disabled = true;
        }

    }

    // Getting data from Child Component to be sent in Rest Api
    const sendLastPeriodData = (genderType, motherHeight, fatherHeight) => {
        heightData = {
            genderType: genderType,
            motherHeight: motherHeight,
            fatherHeight: fatherHeight,
            isToggled: heightData.isToggled
            // hiddenField: hiddenField
        }
        if (heightData.genderType !== '' && heightData.motherHeight !== "" && heightData.motherHeight !== 0 && heightData.fatherHeight !== "" && heightData.fatherHeight !== 0) {
            document.getElementById("calculate-button-id").disabled = false;
        } else {
            document.getElementById("calculate-button-id").disabled = true;
            // setDisableBtn(true);

        }
        // document.getElementById("calculate-button-id").focus();
    }
    const mySubmitHandler = (e) => {
        e.preventDefault()
    }

    const showMainMenu = () => {

        setShowForm(true);
        setShowEditForm(false)
        setTimeout(function () { window.scrollTo(0, 0); }, 0);
        // setDisableBtn(true);
    }

    const getUnitType = (unitType) => {
        // setUnit(unitType);
        // sessionStorage.setItem('unit', unitType)
        if (heightData.genderType !== '' && heightData.motherHeight !== 0 && heightData.fatherHeight !== 0) {
            document.getElementById("calculate-button-id").disabled = false;
        }
        // document.getElementById("calculate-button-id").disabled = false;
    }

    const setUnitData = (unit) => {
        heightData.isToggled = (unit === 'cm') ? false : true
        setUnit(unit)
    }



    // Rendering Component
    return <>
        {componentData.description && <div>
            <section className="" id="main">
                <div className="height-predictor">
                    <div className="calculator-body">
                        {showDesc &&
                            <div className="container">
                                <p className="ovulation-intro" dangerouslySetInnerHTML={{ __html: componentData.description.value }} >
                                </p>
                            </div>}
                        {showEditForm &&
                            <div className="goals-section container-mobile">
                                <div className="recalculate-wrap-period-form">
                                    <div className="container">
                                        <div className="fdlp-mobile">
                                            <span>{componentData.genderTitle.value}</span><span style={{ 'textTransform': 'capitalize' }}>{heightData.genderType.toLocaleLowerCase()}</span>
                                        </div>
                                        <div className="cycle-length-mobile">
                                            <span>{componentData.parentOneTitle.value}</span><span>{heightData.motherHeight} {unit}</span>
                                        </div>
                                        <div className="cycle-length-mobile">
                                            <span>{componentData.parentOneTitle.value}</span><span>{heightData.fatherHeight} {unit}</span>
                                        </div>
                                        <button onClick={showMainMenu}>
                                            <img src="https://dev1.v2.wemshowcase.com/-/media/JssReactWeb/data/media/img/Common/red_pencil.ashx?h=15&amp;w=15&amp;hash=CA6D8D1AE479F86ACEBAF8CBC007C43D" />
                                            <span>Edit</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        }

                        {showForm &&
                            <div>
                                <div className="container">
                                    <div className="form-container">
                                        <form role="form" className="form-inline" onSubmit={mySubmitHandler} noValidate>
                                            <div className="predict-height-fields-wrapper">
                                                <KidsLandingData sendLastPeriodData={sendLastPeriodData} componentData={componentData}
                                                    calculateHeight={calculateHeight} heightData={heightData} getUnitType={getUnitType} setUnitData={setUnitData} />
                                            </div>
                                            <div className="submitBtnWrapper">
                                                <div className="dueDateBtnWrapper">
                                                    <button type="submit" id="calculate-button-id" className="btn red calculate-button" onClick={calculateHeight} disabled={disableBtn}>
                                                        {props.t('HeightPredictor_SubmitButton')}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                            </div>

                        }
                        {!isMobile &&
                            <hr className="form-divider"></hr>
                        }
                        <div className="container">
                            <div className="heightResultSection">
                                {heightPredictorData.showResult && <div className="height-predictor-social-share-component">
                                    <div className="email-share-container">
                                        <p className="share-email-text-msg">Share it with your family and friends!</p>
                                        <Placeholder name="social-share-result" rendering={props.rendering} itemid={props.itemid} />
                                    </div>
                                </div>}
                                {heightPredictorData.showResult && <Results componentData={componentData} heightPredictorData={heightPredictorData.apiData} unit={unit} />}
                                {heightPredictorData.showResult = false}
                            </div>
                        </div>
                    </div>


                    <div className="social-share-container">
                        <div className="container">
                            <Placeholder name="social-share" rendering={props.rendering} itemid={props.itemid} />
                        </div>
                    </div>



                </div>
                <div className="period-calculator-note-section">
                    <p>
                        {componentData.disclaimerMessage.value}
                    </p>
                </div>
            </section>
        </div>}
    </>

}

export default withTranslation()(HeightPredictorCalculation);

